module.exports = __webpack_public_path__ + "static/media/emarton.2b252d2b.jpg";